import { render, staticRenderFns } from "./ModalLOBWidget.vue?vue&type=template&id=932ba4b8&scoped=true&"
import script from "./ModalLOBWidget.vue?vue&type=script&lang=js&"
export * from "./ModalLOBWidget.vue?vue&type=script&lang=js&"
import style0 from "./ModalLOBWidget.vue?vue&type=style&index=0&id=932ba4b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932ba4b8",
  null
  
)

export default component.exports